import { type Option } from '@avanta/shared/components/ui/Select';
import { useFetchSpecialitiesByPsycho } from '@avanta/shared/hooks/useFetchSpecialitiesByPsycho';
import { centersByCity } from '@avanta/shared/utils/appointments';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { type Center } from 'types/appointments';
import { AppointmentsReservePayload } from '../../../types';

export const useGetSpecialityOptions = (
  id: keyof typeof AppointmentsReservePayload
): Option[] | (Center & Option)[] => {
  const { watch } = useFormContext();
  const [city, psychologist] = watch([
    AppointmentsReservePayload.city,
    AppointmentsReservePayload.psychologist,
  ]);
  const { data: bookingOptions } = useFetchSpecialitiesByPsycho({
    psychologistId: psychologist?.id,
  });
  const { workCenters } = bookingOptions ?? {};
  const memoizedCentersByCity = useMemo(() => centersByCity(workCenters ?? []), [workCenters]);

  const optionsMap: Record<string, Option[] | (Center & Option)[]> = {
    [AppointmentsReservePayload.city]: Object.keys(memoizedCentersByCity).map(city => ({
      value: city,
      label: city,
    })),
    [AppointmentsReservePayload.backofficeCenterId]: (memoizedCentersByCity[city] ?? []).map(
      center => ({
        id: String(center.id),
        name: center.name,
        description: `${center.address} ${center.postalCode} ${center.city}`,
        value: String(center.id),
        label: center.name,
      })
    ),
  };

  return optionsMap[id];
};
